import React from "react";
import clsx from "clsx";

import CommentIcon from "@material-ui/icons/Comment";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { getPersonFullName } from "utils/person";
import { transformViewDate } from "utils/date-utils";
import DaysOffDiagram from "components/DaysOffDiagram";
import ExamHistoryItem from "components/VetExams/ExamHistoryItem";
import useStyles from "./styles";

interface IProps {
  horse: racehorse360.IHorse;
  workoutRequest: racehorse360.IWorkoutRequest;
  completedExams: racehorse360.IHorseExam[];
}

const Summary = React.memo((props: IProps) => {
  const { horse, workoutRequest, completedExams } = props;
  const classes = useStyles({
    facilityColor: workoutRequest?.facility?.backgroundColor,
    strokeColor: workoutRequest?.facility?.strokeColor
  });

  const renderNextWorkoutRequest = () => {
    if (workoutRequest) {
      return (
        <>
          <div
            className={clsx(
              classes.blockTitle,
              classes.nextWorkoutRequestTitle
            )}
          >
            Next Workout Request
          </div>
          <div className={classes.workoutInfoWrap}>
            <div className={classes.leftBorder} />
            <div>
              <div className={classes.workoutDate}>
                {transformViewDate(workoutRequest.date, null, "PP")}
              </div>
              <div className={classes.workoutFacility}>
                {workoutRequest.facility.name.toLowerCase()}
              </div>
            </div>
          </div>
          <div className={classes.creatingInfo}>
            <CommentIcon className={classes.commentIcon} />
            <span>Request by&nbsp;</span>
            {getPersonFullName(horse?.trainer, "%f %m %L")}
            {Boolean(horse.trainer?.lastName || horse.trainer?.firstName) && (
              <>&nbsp;on&nbsp;</>
            )}
            {transformViewDate(workoutRequest.createdOn, null, "PPP")}
          </div>
        </>
      );
    }

    return <div className={classes.noContent}>No Workouts Scheduled</div>;
  };

  const renderExamHistory = () => {
    if (!completedExams.length) {
      return (
        <div className={clsx(classes.noContent, classes.noExams)}>
          No Exams History
        </div>
      );
    }

    return (
      <>
        <div className={clsx(classes.blockTitle, classes.examHistoryTitle)}>
          Exam History
        </div>
        {completedExams.map((exam, _, array) => (
          <ExamHistoryItem
            key={exam.id}
            exam={exam}
            withCloneExamButton
            completedExams={completedExams}
          />
        ))}
      </>
    );
  };

  return (
    <>
      <div
        className={clsx(classes.blockWrap, classes.nextWorkoutRequest, {
          ["flexbox"]: !workoutRequest
        })}
      >
        {renderNextWorkoutRequest()}
      </div>
      <div className={clsx(classes.blockWrap, classes.daysSinceLastRace)}>
        <div
          className={clsx(classes.blockTitle, classes.daysSinceLastRaceTitle)}
        >
          Race / Work Days Off
        </div>
        <DaysOffDiagram
          className={clsx(
            { [classes.notEmptyDiagram]: horse?.lastRaceDate },
            classes.daysOffDiagram
          )}
          horse={horse}
          type="line"
        />
      </div>
      <div className={classes.blockWrap}>{renderExamHistory()}</div>
    </>
  );
});

export default Summary;
